import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState, useRef } from "react";
import firebaseApp from "./Firecontact";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";

const validatePhoneNumber = (phoneNumber) => /^[0-9]{10}$/.test(phoneNumber);

const isValidURL = (url) => {
  const pattern = /^(https?:\/\/)?([a-z0-9.-]+)\.[a-z]{2,6}(\/[^\s]*)?$/i;
  return pattern.test(url);
};

const CardPage = () => {
  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    firstName: "",
    phone: "",
    businessName: "",
    businessLink: "",
    city: "",
    address: "",
    forCard: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [imageIndices, setImageIndices] = useState({});
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);

  useEffect(() => {
    const fetchProducts = async () => {
      if (hasFetched.current) return;
      setLoading(true);
      try {
        const db = firebaseApp.firestore();
        const snapshot = await db.collection("product").get();
        const fetchedProducts = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(fetchedProducts);
        initializeImageIndices(fetchedProducts);
        hasFetched.current = true;
      } catch (error) {
        console.error("Error fetching products: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const initializeImageIndices = (products) => {
    const initialIndices = {};
    products.forEach((product) => {
      initialIndices[product.id] = 0;
    });
    setImageIndices(initialIndices);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndices((prevIndices) => {
        const updatedIndices = { ...prevIndices };
        products.forEach((product) => {
          const images = product.images || [product.image];
          updatedIndices[product.id] =
            (prevIndices[product.id] + 1) % images.length;
        });
        return updatedIndices;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [products]);

  const openModal = (product) => {
    setSelectedCard(product.productName);
    setFormData({ ...formData, forCard: product.productName });
    setShowModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValidationErrors((prev) => ({ ...prev, [name]: "" }));
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleClose = () => {
    setFormData({
      firstName: "",
      phone: "",
      businessName: "",
      businessLink: "",
      city: "",
      address: "",
      forCard: "",
    });
    setShowModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const errors = {};
    if (!formData.firstName.trim())
      errors.firstName = "First name is required.";
    if (!formData.businessName.trim())
      errors.businessName = "Business name is required.";
    if (!formData.businessLink.trim()) {
      errors.businessLink = "Business link is required.";
    } else if (!isValidURL(formData.businessLink)) {
      errors.businessLink = "Please enter a valid URL.";
    }
    if (!formData.phone.trim()) {
      errors.phone = "Phone number is required.";
    } else if (!validatePhoneNumber(formData.phone)) {
      errors.phone = "Enter a valid 10-digit number.";
    }
    if (!formData.city.trim()) errors.city = "City is required.";
    if (!formData.address.trim()) errors.address = "Address is required.";

    setValidationErrors(errors);
    if (Object.keys(errors).length > 0) return;

    const message = `
      Order Details From 9R NFC Card:
      - First Name: ${formData.firstName}
      - Business Name: ${formData.businessName}
      - Business Link: ${formData.businessLink}
      - Phone: ${formData.phone}
      - City: ${formData.city}
      - Address: ${formData.address}
      - Selected Card: ${formData.forCard}
    `.trim();

    const phoneNumber = "+919925615191";
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    window.open(whatsappURL, "_blank");

    toast.success("Order sent to WhatsApp successfully!", {
      position: "top-right",
      autoClose: 2000,
    });

    handleClose();
  };

  return (
    <>
      <div style={{ backgroundColor: "#f7f7fc" }}>
        <div className="Exit-Btn">
          <Link
            to={"/"}
            className="ExitBtn d-flex justify-content-center align-items-center border-0 fs-5 py-2 px-3 rounded-1 shadow-lg position-relative overflow-hidden"
          >
            <i className="bi bi-box-arrow-left"></i>
          </Link>
        </div>
        <section className="pb-5 pt-5 bg-white service-categories">
          <div className="container px-4">
            <div className="text-center">
              <h2 className="mb-2 fw-semibold">NFC Card Services</h2>
              <p className="text-center col-md-10 pb-md-5 pb-4 m-auto">
                In an era where speed and security are paramount, 9R NFC Cards
                are redefining the way professionals in India manage business
                networking with smart tap-enabled cards.
              </p>
            </div>

            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading products, please wait...</p>
              </div>
            ) : (
              <div className="row featureCategorySlider pt-1 feature-category-grid">
                {products.map((product) => {
                  const images = product.images || [product.image];
                  const currentIndex = imageIndices[product.id] || 0;
                  return (
                    <div
                      key={product.id}
                      className="rounded productCard h-100 p-0"
                    >
                      <div
                        className="card_product rounded p-0 h-100"
                        onClick={() => openModal(product)}
                      >
                        <img
                          src={images[currentIndex]}
                          alt={product.productName}
                          className="rounded-top w-100"
                          loading="lazy"
                        />
                        <div className="border-yellow p-2 d-flex flex-column align-items-center justify-content-center text-center rounded product-card-body">
                          <span className="fs-6 text-dark fw-500">
                            {product.productName}
                          </span>
                          <div className="d-flex flex-wrap justify-content-center">
                            <span className="text-danger text-decoration-line-through pe-1">
                              ₹{product.price}
                            </span>
                            <span className="text-success">
                              (Offer: {product.offerPrice}%)
                            </span>
                          </div>
                          <div>
                            <span className="fs-6 fw-bold">
                              ₹{product.finalPrice}
                            </span>
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn w-100 fw-bold rounded-0 rounded-bottom border-none"
                          style={{
                            backgroundImage:
                              "linear-gradient(to right, #00d2ff 0%, #3a7bd5 51%, #00d2ff 100%)",
                            textAlign: "center",
                            textTransform: "uppercase",
                            transition: "0.5s",
                            backgroundSize: "200% auto",
                            color: "#fff",
                            borderRadius: "10px",
                            display: "block",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundPosition =
                              "right center";
                            e.currentTarget.style.color = "#fff";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundPosition =
                              "left center";
                          }}
                        >
                          Buy Now
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </section>
      </div>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton className="px-2">
          <Modal.Title>Order Now for {selectedCard}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-2">
          <p>Fill out the form below to place your order for {selectedCard}.</p>

          {[
            { name: "firstName", placeholder: "First Name" },
            { name: "businessName", placeholder: "Business Name" },
            { name: "businessLink", placeholder: "Business Link" },
            { name: "phone", placeholder: "Phone", maxLength: 10 },
            { name: "city", placeholder: "City" },
            { name: "address", placeholder: "Address" },
          ].map((field) => (
            <div className="mb-3" key={field.name}>
              <input
                type="text"
                name={field.name}
                maxLength={field.maxLength}
                className={`form-control ${validationErrors[field.name] ? "is-invalid" : ""
                  }`}
                value={formData[field.name]}
                onChange={handleInputChange}
                placeholder={field.placeholder}
              />
              {validationErrors[field.name] && (
                <div className="invalid-feedback">
                  {validationErrors[field.name]}
                </div>
              )}
            </div>
          ))}

          <div className="mb-3">
            <input
              type="text"
              name="forCard"
              className="form-control"
              value={formData.forCard}
              readOnly
              placeholder="Selected Card"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSubmit}>
            Order Now
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CardPage;